import { Loader2 } from "lucide-react";
import { AriaOrb } from "@/components/AriaOrb";
import { ChatMessage } from "@/components/ChatMessage";

export const MessageList = ({ messages, orbState, sending }) => (
  <div className="max-w-3xl mx-auto space-y-6">
    {messages.length === 0 && (
      <div className="flex flex-col items-center justify-center pt-12 md:pt-20">
        <AriaOrb state={orbState} size={180} />
        <h2 className="font-heading text-2xl md:text-3xl font-light text-white mt-6 text-glow">
          Hola, soy Kai
        </h2>
        <p className="text-slate-400 font-light mt-2 text-center max-w-md">
          Tu asistente de inteligencia artificial, diseñado por Yasser. ¿En qué puedo ayudarte hoy?
        </p>
        <p className="text-slate-500 font-mono text-[11px] mt-4 text-center max-w-md leading-relaxed">
          Comandos de voz: «nueva conversación» · «modo asistente» · «activa/desactiva la voz» · «silencio»
        </p>
      </div>
    )}
    {messages.map((m) => (
      <ChatMessage key={m.ts} role={m.role} content={m.content} streaming={m.streaming} />
    ))}
    {sending && messages[messages.length - 1]?.role !== "assistant" && (
      <div className="flex items-center gap-2 text-cyan-400/80 font-mono text-xs">
        <Loader2 className="w-3.5 h-3.5 animate-spin" /> Procesando la solicitud...
      </div>
    )}
  </div>
);
